import { Color } from '@anov/3d-core'

const TanhaoShader = {
  uniforms: { color: { value: new Color(0, 0, 0) } },
  vertexShader: `
    #include <common>
    #include <logdepthbuf_pars_vertex>
    varying vec3 vNormal; // 用于传递法线方向
    varying vec2 vUv;
    varying vec3 vWorldPosition;
  void main() {
    #include <begin_vertex>
    #include <project_vertex>
    #include <logdepthbuf_vertex>
    // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  vUv = uv;
  vNormal = normalize(mat3(modelMatrix) * normal);  // 使用模型矩阵旋转法线
  vec4 modelPosition = modelMatrix * vec4(position, 1.0);
  vWorldPosition = modelPosition.xyz;
  gl_Position = projectionMatrix * viewMatrix * modelPosition;   
  }
  `,
  fragmentShader: ` 
         #include <common>
         #include <logdepthbuf_pars_fragment>
         varying vec3 vNormal; // 用于传递法线方向
         varying vec2 vUv;
         varying vec3 vWorldPosition;
  
         uniform vec3 color;   
  
        void main() {
        #include <logdepthbuf_fragment>
        float height = 50.;
        float button = 0.;
      //  vec3 myWp=(vWorldPosition-button)/height;       
           gl_FragColor = vec4(color,pow(1.-clamp(1.-vUv.y,0.,1.),2.))   ;    
        }
          `,
}

export default TanhaoShader